export default __webpack_public_path__ + "static/SC_Step_4-9b1fcd3849b88ac231dd2315649ec8c9.svg";